module.exports = __webpack_public_path__ + "img/frost.2f864d94.png";